import * as Icons from "@repo/icons/react";
import type * as BusinessTypeIcons from "@repo/icons/react/business-types";
import type { SVGProps } from "react";
import type { AppIconProps } from "@repo/icons/ui";
import type { CdnBusinessTypeIconVariant } from "./cdn-business-type-icon";
import dynamic from "next/dynamic";

const BusinessTypeIcon = dynamic(() =>
  import("./business-type-icon").then((module) => module.BusinessTypeIcon),
);

export type SupportedIcon = keyof typeof Icons;

export type IconProps = SVGProps<SVGSVGElement> &
  Pick<AppIconProps, "weight"> & {
    icon: SupportedIcon | `BusinessType.${keyof typeof BusinessTypeIcons}`;
    cdnBusinessTypeIconVariant?: CdnBusinessTypeIconVariant;
  };

export function Icon({
  icon,
  cdnBusinessTypeIconVariant,
  weight = "regular",
  ...props
}: IconProps) {
  if (icon.startsWith("BusinessType.")) {
    return (
      <BusinessTypeIcon
        iconName={icon.slice("BusinessType.".length)}
        variant={cdnBusinessTypeIconVariant}
        {...props}
      />
    );
  }
  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: Stored icon keys require the curated shared registry.
  const IconComponent = Icons[icon as SupportedIcon];
  if (!IconComponent) throw new Error(`Icon "${icon}" not found`);

  const iconProps = { ...props, weight };
  return <IconComponent {...iconProps} />;
}

Icon.displayName = "Icon";
